import {Component} from 'react'
import {BsSearch} from 'react-icons/bs'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import Header from '../Header/index'
import UserProfile from '../UserProfile/index'
import JobsList from '../JobsList/index'
import Filters from '../Filters/index'
import './index.css'

const apiStatus = {
  succ: 'SUCCESS',
  fail: 'FAILURE',
  load: 'LOADING',
}

const employmentTypesList = [
  {
    label: 'Full Time',
    employmentTypeId: 'FULLTIME',
  },
  {
    label: 'Part Time',
    employmentTypeId: 'PARTTIME',
  },
  {
    label: 'Freelance',
    employmentTypeId: 'FREELANCE',
  },
  {
    label: 'Internship',
    employmentTypeId: 'INTERNSHIP',
  },
]

const salaryRangesList = [
  {
    salaryRangeId: '1000000',
    label: '10 LPA and above',
  },
  {
    salaryRangeId: '2000000',
    label: '20 LPA and above',
  },
  {
    salaryRangeId: '3000000',
    label: '30 LPA and above',
  },
  {
    salaryRangeId: '4000000',
    label: '40 LPA and above',
  },
]

class Jobs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: apiStatus.load,
      userstatus: apiStatus.load,
      activeSal: '',
      activeType: [],
      search: '',
      jobs: [],
      userDetails: {},
    }
  }

  componentDidMount() {
    this.oper()
    this.useroper()
  }

  onSucc = lis => {
    const obj = lis.map(e => ({
      companyLogoUrl: e.company_logo_url,
      employmentType: e.employment_type,
      id: e.id,
      jobDescription: e.job_description,
      location: e.location,
      packagePerAnnum: e.package_per_annum,
      rating: e.rating,
      title: e.title,
    }))
    this.setState({jobs: obj})
  }

  oper = async () => {
    this.setState({status: apiStatus.load})
    const {activeSal, activeType, search} = this.state
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const empt = activeType.join()
    const url = `https://apis.ccbp.in/jobs?employment_type=${empt}&minimum_package=${activeSal}&search=${search}`
    const resp = await fetch(url, options)
    const res = await resp.json()
    if (resp.ok) {
      this.onSucc(res.jobs)
      this.setState({status: apiStatus.succ})
    } else {
      this.setState({status: apiStatus.fail})
    }
  }

  useroper = async () => {
    this.setState({userstatus: apiStatus.load})
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const resp = await fetch('https://apis.ccbp.in/profile', options)
    const res = await resp.json()
    if (resp.ok) {
      const updprofile = {
        profileImageUrl: res.profile_details.profile_image_url,
        name: res.profile_details.name,
        shortBio: res.profile_details.short_bio,
      }
      this.setState({userstatus: apiStatus.succ, userDetails: updprofile})
    } else {
      this.setState({userstatus: apiStatus.fail})
    }
  }

  typeSalChange = id => {
    this.setState({activeSal: id}, this.oper)
  }

  typeEmpChange = id => {
    this.setState(prevState => {
      const {activeType} = prevState
      if (activeType.includes(id)) {
        const updatedList = activeType.filter(typeId => typeId !== id)
        return {activeType: updatedList}
      }
      return {activeType: [...activeType, id]}
    }, this.oper)
  }

  inpChange = event => {
    this.setState({search: event.target.value})
  }

  usercheck = () => {
    const {userstatus, userDetails} = this.state
    switch (userstatus) {
      case apiStatus.succ:
        return <UserProfile lis={userDetails} />
      case apiStatus.fail:
        return (
          <div>
            <button onClick={this.useroper} type="button">
              Retry
            </button>
          </div>
        )
      case apiStatus.load:
        return this.renderLoad()
      default:
        return null
    }
  }

  left = () => (
    <div className="leftdiv">
      {this.usercheck()}
      <hr />
      <Filters
        typeSalChange={this.typeSalChange}
        typeEmpChange={this.typeEmpChange}
        sal={salaryRangesList}
        emp={employmentTypesList}
      />
    </div>
  )

  renderLoad = () => (
    <div className="loader-container" data-testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  renderFail = () => (
    <div className="loader-container">
      <img
        alt="failure view"
        src="https://assets.ccbp.in/frontend/react-js/failure-img.png"
      />
      <h1>Oops! Something Went Wrong</h1>
      <p>We cannot seem to find the page you are looking for.</p>
      <button onClick={this.oper} type="button">
        Retry
      </button>
    </div>
  )

  renderSucc = () => {
    const {jobs} = this.state
    if (jobs.length === 0) {
      return (
        <div className="loader-container">
          <img
            alt="no jobs"
            src="https://assets.ccbp.in/frontend/react-js/no-jobs-img.png"
          />
          <h1>No Jobs Found</h1>
          <p>We could not find any jobs. Try other filters.</p>
        </div>
      )
    }

    return (
      <ul>
        {jobs.map(e => (
          <JobsList key={e.id} lis={e} />
        ))}
      </ul>
    )
  }

  check = () => {
    const {status} = this.state
    switch (status) {
      case apiStatus.succ:
        return this.renderSucc()
      case apiStatus.fail:
        return this.renderFail()
      case apiStatus.load:
        return this.renderLoad()
      default:
        return null
    }
  }

  right = () => {
    const {search} = this.state
    return (
      <div className="rightdiv">
        <div className="sdiv">
          <input
            onChange={this.inpChange}
            value={search}
            className="inp"
            type="search"
          />
          <button
            onClick={this.oper}
            className="search"
            type="button"
            data-testid="searchButton"
          >
            <BsSearch />
          </button>
        </div>
        <div className="JobsCSS">{this.check()}</div>
      </div>
    )
  }

  render() {
    return (
      <div className="jobsmdiv">
        <Header />
        <div className="jobsdiv">
          {this.left()}
          {this.right()}
        </div>
      </div>
    )
  }
}

export default Jobs
